var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareExplorer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 22.2521C42.0281 24.4305 44 27.9849 44 32C44 38.6274 38.6274 44 32 44C28.446 44 25.2529 42.455 23.0556 40H0V38H2V16H9V38H12V0H19V38H21.6054C20.5844 36.235 20 34.1857 20 32C20 29.5465 20.7363 27.265 22 25.3644V6H29V20.3781C29.9589 20.1313 30.9641 20 32 20V11H39V22.2521ZM22.0494 33C22.5184 37.7244 26.2756 41.4816 31 41.9506V40H33V41.9506C37.7244 41.4816 41.4816 37.7244 41.9506 33H40V31H41.9506C41.4816 26.2756 37.7244 22.5184 33 22.0494V24H31V22.0494C26.2756 22.5184 22.5184 26.2756 22.0494 31H24V33H22.0494ZM4 18V38H7V18H4ZM14 2V38H17V2H14ZM27 21.0881V8H24V23.0556C24.8904 22.2586 25.9005 21.5927 27 21.0881ZM37 21.0881V13H34V20.1659C35.0528 20.3425 36.0591 20.6563 37 21.0881ZM36.9497 27.0503L33.7678 33.7678L27.0503 36.9497L30.2322 30.2322L36.9497 27.0503Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareExplorer);
export default __webpack_public_path__ + "static/media/share-explorer.39121268dd1df4b99d2580a8f17f4e97.svg";
export { ForwardRef as ReactComponent };